// extracted by mini-css-extract-plugin
module.exports = {"content-root":"Modal-module__content-root__2RqRp","close-modal":"Modal-module__close-modal__23aht"};